import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api_url } from "../../helpers/apiHelpers";
import { toast } from "react-toastify";

const PrintLeaveEncashment = () => {
  const navigate = useNavigate();
  const route = useParams().id;
  const userId = localStorage.getItem("userId");
  const [PensionProposalData, setPensionProposalData] = useState([]);
  const getPensionProposalData = async () => {
    try {
      const response = await fetch(
        `${api_url}/api/users/get-pension_proposal-data`,
        {
          method: "POST",
          body: JSON.stringify({
            userId,
          }),
          headers: {
            "Content-Type": "application/json; charset=UTF-8",
          },
        }
      );
      const result = await response.json();
      if (result.status === 201) {
        let singleData = result.result.find((item) => item._id === route);

        setPensionProposalData(singleData);
      } else {
        setPensionProposalData([]);
      }
    } catch (error) {
      toast.error("Something failed. Please try again.");
    }
  };

  useEffect(() => {
    getPensionProposalData();
  }, [userId]);
  const [formData, setFormData] = useState([]);
  const [familyMember, setfamilyMember] = useState([]);
  useEffect(() => {
    try {
      if (PensionProposalData?.formData) {
        setFormData(JSON.parse(PensionProposalData.formData));
      }
      if (PensionProposalData?.familyMember) {
        setfamilyMember(JSON.parse(PensionProposalData.familyMember));
      }
    } catch (error) {
      console.error("Error parsing JSON data:", error);
    }
  }, [PensionProposalData]);

  const [serviceDurationYears, ServiceDurationYears] = useState(0);
  const [serviceDurationMonth, setServiceDurationMonth] = useState(0);
  // Update the home rent whenever formData changes
  useEffect(() => {
    // Function to extract years (वर्ष) as a string
    const getYears = (text) => {
      if (text) {
        const parts = text.split(","); // Split by commas
        const yearsPart = parts.find((part) => part.includes("वर्ष")); // Find the part with "वर्ष"

        if (yearsPart) {
          // Extract the number before "वर्ष" using regex
          const match = yearsPart.match(/\d+/); // Match numeric digits
          return match ? parseInt(match[0], 10) : null; // Return the number or null
        }
      }

      return null; // Return null if "वर्ष" is not found
    };
    const getMonths = (text) => {
      if (text) {
        const parts = text.split(","); // Split by commas
        const monthsPart = parts.find((part) => part.includes("महिने")); // Find the part with "महिने"

        if (monthsPart) {
          // Extract the number before "महिने" using regex
          const match = monthsPart.match(/\d+/); // Match numeric digits
          return match ? parseInt(match[0], 10) : null; // Return the number or null
        }

        return null; // Return null if "महिने" is not found
      }
    };

    // Example usage:
    const months = getMonths(formData && formData.serviceDuration);

    const years = getYears(formData && formData.serviceDuration);
    setServiceDurationMonth(
      months >= 3 && months < 9 ? 1 : months >= 9 && months < 12 ? 2 : 0
    );

    const result = getYears(formData.serviceDuration);
    ServiceDurationYears(result); // Output: "4 वर्ष"
  }, [formData.serviceDuration]);

  const [serviceDurationMonth1, setServiceDurationMonth1] = useState(0);

  useEffect(() => {
    setServiceDurationMonth1(
      serviceDurationYears > 33
        ? Math.round(33 * 2)
        : Math.round(serviceDurationYears * 2 + serviceDurationMonth)
    );
  }, [
    formData.birthDateNumber,
    formData.appointmentDate,
    formData.retirementDate,
    serviceDurationYears,
    serviceDurationMonth,
  ]);

  const generatePrintablePage = async () => {
    // Add dynamic CSS for proper page breaks and consistent layout
    const style = document.createElement("style");
    style.innerHTML = `
                /* General styling */
                * {
                  padding: 0px !important;
                  margin: 0px !important;
                  font-size: 14px !important;
                  color: #000 !important;
                  box-sizing: border-box; /* Maintain consistent sizing */
                }
                .commonClassTable{
                  margin: 0px 0 !important;
                  width:100% !important;
                }
                #leave_encashment-print {
                  width: 100%;
                }
                table th,table td{
                  padding: 2px 5px !important;
                }
                  
                /* Ensure each section prints on its own page */
                #leave_encashment-print > div {
                  page-break-after: always; /* Force each child div to print on a new page */
                  page-break-inside: avoid; /* Avoid breaking inside sections */
                }
                
          
                /* Page setup */
                @page {
                  size: A4; /* Set the page size to A4 */
                  margin: 10mm 10mm 10mm 10mm !important; /* Set page margin */
                }
            
                @media print {
                  body {
                    margin: 0;
                    padding: 0;
                  }
            
                  /* Hide unnecessary sections like buttons */
                  #button-section {
                    display: none;
                  }
                }
              `;
    document.head.appendChild(style);

    // Get the #inter-district-transfer-print element
    const printContent = document.getElementById("leave_encashment-print");

    if (printContent) {
      // Clone the content for printing
      const printWrapper = document.createElement("div");
      printWrapper.id = "print-wrapper";

      // Clone each child element of #inter-district-transfer-print
      Array.from(printContent.children).forEach((child) => {
        const clone = child.cloneNode(true);
        printWrapper.appendChild(clone);
      });

      // Append the cloned content to the body
      document.body.appendChild(printWrapper);

      // Trigger the print dialog
      window.print();

      // Clean up after printing
      document.body.removeChild(printWrapper);
      document.head.removeChild(style);
    } else {
      alert("No content available for printing.");
    }
  };
  return (
    <div className="container-xl py-3">
      <div className="row my-4" id="button-section">
        <div className="col-lg-4">
          <button
            className="btn btn-primary"
            onClick={() => navigate("/dashboard/pension_proposal")}
          >
            Back
          </button>
        </div>
      </div>
      <div id="leave_encashment-print" className="leave_encashment-print mt-3">
        <div id="section1" className="commonClassTable border px-5 py-5">
          <div className="row mt-2">
            <div className="col-lg-7 col-md-7 col-7"></div>
            <div className="col-lg-5 col-md-5 ms-auto col-5">
              <p className="fw-bold ">दिनांक :</p>
            </div>
          </div>

          <p className="fw-bold mt-1">प्रति,</p>
          <p className="fw-bold mt-1"> मा. मुख्य कार्यकारी अधिकारी,</p>
          <p className="fw-bold mt-1">{formData && formData.currentDistrict}</p>
          <p class="textIndent mt-3">
            विषय :- स्वेच्छा सेवानिवृत्ती सेवानिवृत्त झाल्यामुळे अर्जित रजा
            रोखीकरण मंजुर करणे बाबत{" "}
            <b>
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>
          </p>
          <p className="fw-bold text-left mt-2">
            Sevarth ID : {formData && formData.sevarthID}
          </p>

          <p className="mt-3">महोदय,</p>
          <p class="textIndent mt-2">
            वरील विषयी सविनय सादर करण्यात येते की, मी दिनांक{" "}
            <b>{formData && formData.retirementDate}</b> रोजी जिल्हा परिषद
            सेवेतुन <b>{formData && formData.retirementType}</b> सेवा निवृत्त
            होते आहे. करिता आपणांस विनंती करण्यात येते की, महाराष्ट्र नागरी सेवा
            रजा नियम १९८१ मधील कलम ६९ मधील तरतुदीनुसार माझे अर्जित रजा लेखा खाती
            शिल्लक अर्जित रजेचे रोखीकरण{" "}
            <b>{formData && formData.cashingOutEarnedLeave}</b> दिवसाचे अर्जित
            रजा रोखीकरणाचा प्रस्ताव रजा अवेदन पत्रासह यासोबत सादर करण्यात येत
            आहे
          </p>
          <p class="textIndent mt-2">
            कृपया वरिल प्रमाणे अर्जित रजा रोखीकरणे मंजुर करावे हि विनंती
          </p>
          <p class="textIndent fw-bold mt-2">
            सोबत प्रस्ताव व रजेचे आवेदनपत्र व मूळ सेवापुस्तिका
          </p>
          <div className="row  align-items-center">
            <div className="col-lg-8 col-8 col-md-8">
              {/* <p className="fw-bold mt-3">
                ठिकाण :- {formData && formData.officeName}
              </p>
              <p className="fw-bold mt-2">दिनांक :-</p> */}
            </div>

            <div className="col-lg-4 col-4 col-md-4 text-center ">
              <p className="fw-bold mt-3 text-center">आपला विश्वासू,</p>
              <input type="text" className="py-3" readOnly />
              <p className="fw-bold mt-1 text-center">
                {formData && formData.fullName},
                {formData && formData.designation}
              </p>
              <p className="fw-bold mt-1 text-center">
                {formData && formData.officeName}
              </p>
            </div>
          </div>
        </div>

        <div id="section2" className="commonClassTable border px-5 py-5">
          <div className="row mt-2">
            <div className="col-lg-7 col-md-7 col-7"></div>
            <div className="col-lg-5 col-md-5 ms-auto col-5">
              <p className="fw-bold">
                {formData && formData.officeSerialNumber}
              </p>
              <p className="fw-bold">{formData && formData.officeName}</p>
              <p className="fw-bold ">दिनांक :</p>
            </div>
          </div>

          <p className="fw-bold mt-1">प्रति,</p>
          <p className="fw-bold mt-1"> मा. मुख्य कार्यकारी अधिकारी,</p>
          <p className="fw-bold mt-1">{formData && formData.currentDistrict}</p>
          <p className="text-left mt-3">
            विषय :- स्वेच्छा सेवानिवृत्ती सेवानिवृत्त झाल्यामुळे अर्जित रजा
            रोखीकरण मंजुर करणे बाबत{" "}
          </p>
          <p className="textIndent text-left mt-3">
            <b>
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>
          </p>
          <p className="fw-bold text-left mt-2">
            Sevarth ID : {formData && formData.sevarthID}
          </p>
          <p className="textIndent text-left mt-3">
            संदर्भ :- १ संबंधितांचा अर्ज दिनांक
          </p>

          <p className="mt-3">महोदय,</p>
          <p class="textIndent">
            वरिल विषयी संदर्भीय अर्जान्वये{" "}
            <b>
              {formData && formData.fullName},{formData && formData.designation}
              , {formData && formData.officeName}
            </b>{" "}
            यांनी त्यांचे अर्जित रजा खाती शिल्लक अर्जित रजेचे रोखीकरण मंजुर करणे
            बाबत विनंती अर्जासह रजा अवेदन पत्र सादर केलेले आहे
          </p>
          <p class="textIndent mt-3">
            <b>
              {formData && formData.fullName},{formData && formData.designation}
            </b>{" "}
            हे दिनांक{" "}
            <b>
              {formData && formData.retirementDate} रोजी{" "}
              {formData && formData.retirementType}
            </b>{" "}
            जिल्हा परिषद सेवेतून सेवानिवृत्त झालेले आहेत. सेवा निवृत्तीच्या
            दिवशी त्यांचे अर्जित रजेच्या खाती{" "}
            <b>{formData && formData.cashingOutEarnedLeave}</b> दिवस रजा शिल्लक
            आहे.
          </p>
          <p class="textIndent">
            करिता संबंधिताचे सदरील रजा रोखीकरण हे महाराष्ट्र नागरी सेवा रजा नियम
            १९८१ चे कलम ६९ नुसार मंजुर करणे बाबत प्रस्ताव यासोबत सादर करण्यात
            येत आहे. करिता सदर प्रस्तावास मंजूरी प्रदान करावी हि विनंती.
          </p>
          <p class="textIndent">
            सोबत प्रस्ताव व रजेचे आवेदनपत्र व मूळ सेवापुस्तिका
          </p>
          <div className="row mt-5 align-items-center">
            <div className="col-lg-8 col-8 col-md-8"></div>

            <div className="col-lg-4 col-4 col-md-4 text-center mt-4">
              <p className="fw-bold mt-1 text-center">
                {formData && formData.officerDesignation}
              </p>
              <p className="fw-bold mt-1 text-center">
                {formData && formData.officeName}
              </p>
            </div>
          </div>
        </div>

        <div id="section3" className="commonClassTable border px-5 py-5">
          <h3 className="fw-bold text-2xl border w-75 py-2 m-auto text-center mb-1">
            नमुना - 1 : अर्जाचे आवेदन पत्र
          </h3>
          <p class="text-center text-sm">
            (महाराष्ट्र नागरी सेवा ( रजा ) नियम १९८१ मधील नियम २४ पहा){" "}
          </p>
          <table class="table table-bordered mt-3">
            <tbody>
              <tr>
                <td>1. अर्जदाराचे नाव</td>
                <td>
                  <b>{formData && formData.fullName}</b>
                </td>
              </tr>
              <tr>
                <td>2. धारण केलेले पद</td>
                <td>
                  <b>{formData && formData.designation}</b>
                </td>
              </tr>
              <tr>
                <td>3. विभाग, उपविभाग व शाखा</td>
                <td>
                  <b>{formData && formData.officeName}</b>
                </td>
              </tr>
              <tr>
                <td>4. वेतन</td>
                <td>
                  <b>{formData && formData.salaryRange}</b>
                  <br />
                  मूळ वेतन : <b>{formData && formData.baseSalary}</b>
                </td>
              </tr>
              <tr>
                <td>5. सध्या पदावर मिळणारा घरभाडे भत्ता आणि इतर पूरक भत्ते</td>
                <td>
                  घरभाडे भत्ता : <b>{formData && formData.homeRent}</b>
                  <br />
                  महागाई भत्ता :{" "}
                  <b>{formData && formData.dearnessAllowanceRate}</b>
                </td>
              </tr>
              <tr>
                <td>
                  6. मागितलेल्या रजेचे स्वरूप कालावधी आणि रजाच्या तारखेपासून
                  पाहिजे असेल ती तारीख
                </td>
                <td>
                  महाराष्ट्र नागरी सेवा नियम 1986 / महिलेच्या 16% प्रवर्गाचा
                  राजा
                </td>
              </tr>
              <tr>
                <td>
                  7. रजेच्या मागे पुढे असल्यास जोडून घ्यावयाची रविवार व सुट्टीचे
                  दिवस
                </td>
                <td>
                  <b>{formData && formData.cashingOutEarnedLeave}</b> दिवस (राजा
                  रजा रोजनिशी प्रमाणे)
                </td>
              </tr>
              <tr>
                <td>8. रजा मागण्याची कारणे </td>
                <td>
                  <b>{formData && formData.retirementType}</b>
                </td>
              </tr>
              <tr>
                <td>
                  9. पूर्वी घेतलेल्या रजेवरून परत आल्याची तारीख आणि त्या
                  राज्याचे स्वरूप कालावधी{" "}
                </td>
                <td>
                  <b>{formData && formData.retirementType}</b>
                </td>
              </tr>

              <tr>
                <td>रजेच्या कालावधीतील पत्ता</td>
                <td>
                  <b>{formData && formData.address}</b>
                </td>
              </tr>
              <tr>
                <td>
                  मी राजीनामा दिल्यास किंवा स्वच्छतेने सेवानिवृत्ती झाल्यास पुढे
                  नमूद केलेल्या रकमा परत करण्याची हमी देत आहे
                </td>
              </tr>
            </tbody>
          </table>
          <div className="row  align-items-center">
            <div className="col-lg-8 col-8 col-md-8">
              {/* <p className="fw-bold mt-3">
                ठिकाण :- {formData && formData.officeName}
              </p>
              <p className="fw-bold mt-2">दिनांक :-</p> */}
            </div>

            <div className="col-lg-4 col-4 col-md-4 text-start ">
              <p className="fw-bold mt-1 text-start py-3">
                अर्जदाराची स्वाक्षरी :-
              </p>

              <p className="fw-bold mt-1 text-start">
                अर्जदाराचे नाव :- {formData && formData.fullName}
              </p>
              <p className="fw-bold mt-1 text-start">
                पदनाम :- {formData && formData.designation}
              </p>
            </div>
          </div>
        </div>
        <div id="section4" className="commonClassTable border px-5 py-5">
          <h3 className="fw-bold text-2xl border w-75 py-2 m-auto text-center mb-1">
            कार्यालीन उपयोगाकरिता
          </h3>
          <p>
            संबंधिताचे अर्जित रजा रोखीकरणाच्या प्रस्तावाची पडताळणी केली असता.
            संबंधिताचे मूळ वेतन तसेच सेवा निवृत्तीच्या दिवशी रजेच्या खाती शिल्लक
            असलेली रजा बरोबर असल्याचे आढळून आले आहे.
          </p>
          <p>
            करिता संबंधिताचे उपरोक्त प्रमाणे महाराष्ट्र नागरी सेवा रजा नियम १९८१
            मधील कलम ६९ अन्वये अर्जित रजा रोखीकरण मंजूर करण्यात येत आहे. त्याचा
            तपशिल खालील प्रमाणे आहे.
          </p>
          <th>पदनाम</th>
          <th>वेतनमान</th>
          <td>कनिष्ठ सहाय्यक</td>
          <td>S-13: 35400-112400</td>
          <table class="table table-bordered text-center">
            <tbody>
              <tr>
                <th className="bg-info">वेतनश्रेणी </th>
                <td>{formData && formData.salaryRange}</td>
                <th className="bg-info">मूळ वेतन</th>
                <td>{formData && formData.baseSalary}</td>
                <th className="bg-info">सेवानिवृत्तीचे वेळी महागाई भत्ता दार </th>
                <td>{formData && formData.daRange}%</td>
              </tr>
            </tbody>
          </table>
          <table class="table table-bordered text-center">
            <thead className="bg-info">
              <tr>
                <th>मूळ वेतन</th>
                <th>महागाई भत्ता</th>
                <th>एकूण वेतन</th>
                <th>रजा खाती शिल्लक असलेले दिवस</th>
                <th>रजाचे रोकडीतून मूल्य</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{formData && formData.baseSalary}</td>
                <td>{formData && formData.dearnessAllowanceRate}</td>
                <td>
                  {formData &&
                    parseInt(formData.baseSalary) +
                      parseInt(formData.dearnessAllowanceRate)}
                </td>
                <td>{formData && formData.cashingOutEarnedLeave}</td>
                <td>
                  {formData &&
                    parseInt(formData.baseSalary) +
                      parseInt(formData.dearnessAllowanceRate)}
                  0
                </td>
              </tr>
            </tbody>
          </table>
          <div className="row mt-5 align-items-center">
            <div className="col-lg-8 col-8 col-md-8">
              {/* <p className="fw-bold mt-3">
                ठिकाण :- {formData && formData.officeName}
              </p>
              <p className="fw-bold mt-2">दिनांक :-</p> */}
            </div>

            <div className="col-lg-4 col-4 col-md-4 text-start ">
              <p className="fw-bold mt-3 text-center">
                {formData && formData.hodDesignation}
              </p>
              <p className="fw-bold mt-1 text-center">
                {formData && formData.currentDistrict}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="row my-4" id="button-section">
        <div className="col-lg-4 m-auto">
          <button
            className="btn btn-primary btn-lg w-100"
            onClick={() => generatePrintablePage()}
          >
            Print
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrintLeaveEncashment;
